export const STATES = [
  { _id: "AS", title: "AGUASCALIENTES" },
  { _id: "BC", title: "BAJA CALIFORNIA" },
  { _id: "BS", title: "BAJA CALIFORNIA SUR" },
  { _id: "CH", title: "CHIHUAHUA" },
  { _id: "CS", title: "CHIAPAS" },
  { _id: "CC", title: "CAMPECHE" },
  { _id: "DF", title: "CIUDAD DE MEXICO" },
  { _id: "CL", title: "COAHUILA" },
  { _id: "CM", title: "COLIMA" },
  { _id: "DG", title: "DURANGO" },
  { _id: "GR", title: "GUERRERO" },
  { _id: "GT", title: "GUANAJUATO" },
  { _id: "HG", title: "HIDALGO" },
  { _id: "JC", title: "JALISCO" },
  { _id: "MN", title: "MICHOACAN" },
  { _id: "MC", title: "ESTADO DE MEXICO" },
  { _id: "MS", title: "MORELOS" },
  { _id: "NT", title: "NAYARIT" },
  { _id: "NL", title: "NUEVO LEON" },
  { _id: "OC", title: "OAXACA" },
  { _id: "PL", title: "PUEBLA" },
  { _id: "QR", title: "QUINTANA ROO" },
  { _id: "QT", title: "QUERETARO" },
  { _id: "SL", title: "SINALOA" },
  { _id: "SP", title: "SAN LUIS POTOSI" },
  { _id: "SR", title: "SONORA" },
  { _id: "TC", title: "TABASCO" },
  { _id: "TL", title: "TLAXCALA" },
  { _id: "TS", title: "TAMAULIPAS" },
  { _id: "VZ", title: "VERACRUZ" },
  { _id: "YN", title: "YUCATAN" },
  { _id: "ZS", title: "ZACATECAS" },
];

export const GENDERS = [
  { _id: "H", title: "HOMBRE" },
  { _id: "M", title: "MUJER" },
];
